<div class="searchBox" [ngClass]="{'focused':focused,
 									'clearButtonIsVisible': enableClearButton && showClearButton,
 									'modified': isModified}">
	<div class="searchBoxInput">
		<input #searchInput [cpFocus]="focusOnInit"
			   (focus)="focusChange.emit()"
			   (blur)="blurChange.emit()"
			   type="text"
			   [attr.inputmode]="inputMode"
			   placeholder="{{placeHolder}}"
			   (keyup.enter)="onSearch($event)"
			   (keydown)="onKeydown($event)"
			   (mousedown)="onMouseDown($event)"
			   [ngModel]="searchString"
			   (ngModelChange)="onSearchChange($event)"
			   [readonly]="readOnly">
	</div>
	<a class="searchBoxButton clear-button"
	   (click)="onClearHandler()">
		<i class="cp-icon-procedure_delete"></i>
	</a>
	<a *ngIf="customButton" class="searchBoxButton custom-button cp-icon-color-1">
		<i *ngIf="customButton.class" class="{{customButton.class}}" (click)="onCustomButtonCLick($event);"></i>
	</a>
	<a class="searchBoxButton submit-button cp-icon-color-1"
	   (click)="onSearch($event)"
	   [class.disabled]="isDisabled()">
		<i class="search-icon" [class]="overrideSearchIconClass?overrideSearchIconClass:'cp-icon-search'"></i>
	</a>
</div>
